module.exports = __webpack_public_path__ + "static/media/red-info-icon.0886f4a5.svg";